export const EVENT_COLORS = {
  vacation_approved: { bar: 'bg-emerald-500', text: 'text-white', label: 'Urlaub (genehmigt)' },
  vacation_pending: { bar: 'bg-amber-400', text: 'text-amber-950', label: 'Urlaub (beantragt)' },
  sick: { bar: 'bg-red-500', text: 'text-white', label: 'Krankheit' },
  child_sick: { bar: 'bg-orange-500', text: 'text-white', label: 'Kind krank' },
  parental_leave: { bar: 'bg-sky-500', text: 'text-white', label: 'Elternzeit' },
  sick_no_note: { bar: 'bg-rose-500', text: 'text-white', label: 'KO-Tag (krank ohne Schein)' },
  other_absence: { bar: 'bg-slate-500', text: 'text-white', label: 'Sonstige Abwesenheit' },
};
